import React from 'react';

export interface DashboardsContextType {
  // Active (non-archived) dashboards. Does not include dashboards with isHidden: true.
  allDashboards: DashboardType[];
  // Dashboards with isHidden: true. Only exposed for the staff-only Archived view.
  archivedDashboards: DashboardType[];
  isLoading: boolean;
  addOrUpdateDashboard: (newDashboard: DashboardType) => void;
}
const DashboardsContext = React.createContext<DashboardsContextType>({
  allDashboards: [],
  archivedDashboards: [],
  isLoading: true,
  addOrUpdateDashboard: () => {},
});

export default DashboardsContext;
